import { render, staticRenderFns } from "./synchron.vue?vue&type=template&id=ef700470&scoped=true&"
import script from "./synchron.vue?vue&type=script&lang=js&"
export * from "./synchron.vue?vue&type=script&lang=js&"
import style0 from "./synchron.vue?vue&type=style&index=0&id=ef700470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef700470",
  null
  
)

export default component.exports